module.exports = __webpack_public_path__ + "img/mcgl_fp_06.92d165af.png";